var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpectedTermsAndRates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.6 50.2601C8.14 50.2601 10.2 48.2001 10.2 45.6601V41.0601H4.9C2.75 41.0601 1 42.8001 1 44.9601V45.6601C1 48.2001 3.06 50.2601 5.6 50.2601Z",
    fill: "#FFCF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2486 4.69V46.46L50.0386 48.77L47.4486 50.19H7.05859L10.1986 47.05V4.69C10.1986 2.65 11.8486 1 13.8886 1H47.5586C49.5986 1 51.2486 2.65 51.2486 4.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2492 41.06V5.06C51.2492 2.82 49.4292 1 47.1892 1H14.2592C12.0192 1 10.1992 2.82 10.1992 5.06V41.07",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9414 30.6401H44.5114",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9414 36.3901H44.5114",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9414 42.1499H44.5114",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6 50.2601C8.14 50.2601 10.2 48.2001 10.2 45.6601V41.0601H5.05C2.81 41.0601 1 42.8801 1 45.1201V45.6701C1 48.2001 3.06 50.2601 5.6 50.2601Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6484 50.2601C49.1884 50.2601 51.2484 48.2001 51.2484 45.6601V41.0601",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6516 50.2598H44.5116H5.60156",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6688 15.06C27.0088 15.84 26.0088 16.22 24.6888 16.22C23.3588 16.22 22.3687 15.83 21.7087 15.06C21.0487 14.28 20.7188 13.24 20.7188 11.93C20.7188 10.62 21.0487 9.57998 21.7087 8.79998C22.3687 8.01998 23.3688 7.63998 24.6888 7.63998C26.0188 7.63998 27.0088 8.02998 27.6688 8.79998C28.3288 9.57998 28.6588 10.62 28.6588 11.93C28.6588 13.24 28.3388 14.29 27.6688 15.06ZM24.0888 14.07C24.2488 14.2 24.4488 14.26 24.6888 14.26C24.9288 14.26 25.1288 14.2 25.2888 14.07C25.4488 13.94 25.5488 13.74 25.6088 13.46C25.6588 13.18 25.6987 12.95 25.7087 12.76C25.7188 12.57 25.7288 12.3 25.7288 11.93C25.7288 11.57 25.7188 11.29 25.7087 11.1C25.6887 10.91 25.6588 10.68 25.6088 10.4C25.5588 10.12 25.4488 9.91998 25.2888 9.78998C25.1288 9.65998 24.9288 9.59998 24.6888 9.59998C24.4488 9.59998 24.2488 9.65998 24.0888 9.78998C23.9288 9.91998 23.8288 10.12 23.7688 10.4C23.7188 10.68 23.6788 10.91 23.6688 11.1C23.6488 11.29 23.6488 11.56 23.6488 11.93C23.6488 12.29 23.6588 12.57 23.6688 12.76C23.6788 12.95 23.7188 13.18 23.7688 13.46C23.8188 13.74 23.9288 13.94 24.0888 14.07ZM24.7288 24.14L33.9988 7.22998H36.4888L27.2188 24.14H24.7288ZM33.7787 22.57C33.1187 21.79 32.7888 20.75 32.7888 19.44C32.7888 18.13 33.1187 17.08 33.7787 16.31C34.4387 15.53 35.4387 15.15 36.7587 15.15C38.0887 15.15 39.0788 15.54 39.7388 16.31C40.3988 17.09 40.7288 18.13 40.7288 19.44C40.7288 20.75 40.3988 21.8 39.7388 22.57C39.0788 23.35 38.0787 23.73 36.7587 23.73C35.4387 23.73 34.4387 23.34 33.7787 22.57ZM35.7388 18.61C35.7188 18.8 35.7188 19.07 35.7188 19.44C35.7188 19.8 35.7288 20.08 35.7388 20.27C35.7488 20.46 35.7888 20.69 35.8388 20.97C35.8888 21.25 35.9988 21.45 36.1588 21.58C36.3188 21.71 36.5187 21.77 36.7587 21.77C36.9987 21.77 37.1988 21.71 37.3588 21.58C37.5188 21.45 37.6188 21.25 37.6788 20.97C37.7288 20.69 37.7687 20.46 37.7787 20.27C37.7887 20.08 37.7987 19.81 37.7987 19.44C37.7987 19.08 37.7887 18.8 37.7787 18.61C37.7587 18.42 37.7288 18.19 37.6788 17.91C37.6288 17.63 37.5188 17.43 37.3588 17.3C37.1988 17.17 36.9987 17.11 36.7587 17.11C36.5187 17.11 36.3188 17.17 36.1588 17.3C35.9988 17.43 35.8988 17.63 35.8388 17.91C35.7888 18.19 35.7588 18.42 35.7388 18.61Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpectedTermsAndRates);
export default __webpack_public_path__ + "static/media/ExpectedTermsAndRates.dea26aaf8525f5ff07820b3c166343c6.svg";
export { ForwardRef as ReactComponent };